import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ErrorHandler } from '../../../../shared/ErrorHandler';
import { UserService } from '../../../../shared/user.service';
import swal from 'sweetalert2';
import { NgForm } from '@angular/forms';
declare var $: any;
@Component({
  selector: 'app-vendorform',
  templateUrl: './vendorform.component.html',
  styleUrls: ['./vendorform.component.css']
})
export class VendorformComponent implements OnInit {
title =  'Pharmacy Details';
data : any = {};
formInvalid : boolean = false;
d : any = {};
fileToUpload: File = null;

VE_Id : number;
mode : string;
ActiveDetailsList: any=[];
ActiveDetails: any=[];
ActiveDetail: any=[];
ActiveDetai: any=[];
Active: any=[];
ActiveDistrict: any=[];
photoImageUrl: any;
AS_Photo: string;
Activespili: any=[];
constructor(public service : UserService,private router: Router,private route: ActivatedRoute,  private errorHandler: ErrorHandler) { }

ngOnInit() {

  this.GetState();
  this.GetsDistrict();

  this.route.params.subscribe(params => {      
    this.VE_Id = params['VE_Id'];  
    this.mode  =   params['mode'];   
      
      if(this.VE_Id > 0){
        this.getbyid(this.VE_Id)
      }    
      
  });

  if(this.mode=='view'){
    this.title = "View Pharmacy";
  }
  else if(this.mode=='edit'){
    this.title = "Edit Pharmacy";
  } 
 
}
SaveDistrict(Distict: NgForm){
      
  if(Distict.invalid)
  {
    this.formInvalid = true;
    swal('Warning!', 'Please fill all the mandatory fields.', 'warning');
    return;
  }     

  else{                                     
          this.data = this.service.Postvender(Distict.value);    
          this.data.subscribe(
          (response) => {
            Distict.reset();
            Distict.resetForm();
            Distict.form.markAsPristine();
            Distict.form.markAsUntouched();        
            swal('Success!', 'Vender Added Successfully .', 'success');
            this.router.navigate(['/home/vendor']) ;   
            document.getElementById('loader-spinner').style.display = "none";           
          }, (error) => {
            document.getElementById('loader-spinner').style.display = "none";
            if (error.status == 401) {
              this.errorHandler.HandlerError(error);
            }
            else if (error.status == 400) {
              swal('Warning!', error.error.Message, 'warning');
            }
          });    
  
  
  } 
}


UpdateDistrict(District: NgForm) {  
  this.data = this.service.updatevender(District.value,this.VE_Id);
 this.data.subscribe(
   (response) => {
    District.reset();
    District.resetForm();
    District.form.markAsPristine();
    District.form.markAsUntouched();           
                 
     swal('Success!', 'Vender updated Successfully .', 'success');
     this.router.navigate(['/home/vendor']) ;  
     document.getElementById('loader-spinner').style.display = "none";   
            
   }, (error) => {
     document.getElementById('loader-spinner').style.display = "none";
     if (error.status == 401) {
       this.errorHandler.HandlerError(error);
     }
     else if (error.status == 400) {
      swal('Warning!', error.error.Message, 'warning');
     }
   });   
}

Cancel(){
//this.router.navigate(['/menu/master']) ; 
this.d.district_name='';
this.d.district_id='';
}

    GetState(){
      //alert('Inside');
      
      
        document.getElementById('loader-spinner').style.display = "block";
        this.data = this.service.GetallCategory();
        this.data.subscribe(
          (response: any) => {
            this.Active = response;
          document.getElementById('loader-spinner').style.display = "none";
          }, (error) => {
            document.getElementById('loader-spinner').style.display = "none";
          });
      }
      GetsDistrict(){
        //alert('Inside');
        
        
          document.getElementById('loader-spinner').style.display = "block";
          this.data = this.service.GetallCategorydrop();
          this.data.subscribe(
            (response: any) => {
              this.ActiveDistrict = response;
            document.getElementById('loader-spinner').style.display = "none";
            }, (error) => {
              document.getElementById('loader-spinner').style.display = "none";
            });
        }
     
       
        getbyid(VE_Id) {
          {
            
           // this.a.Image_path=this.photoImageUrl;
            document.getElementById('loader-spinner').style.display = "block";
            this.data = this.service.getbyvender(VE_Id);
            this.data.subscribe(
              (response: any) => {
              this.d = response;
           document.getElementById('loader-spinner').style.display = "none";
              }, (error) => {
                document.getElementById('loader-spinner').style.display = "none";
              });
          }
      
        }
      
}



// WEBPACK FOOTER //
// ./src/app/Pages/manage/vendor/vendorform/vendorform.component.ts